import './polyfill';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ClearCacheProvider } from 'react-clear-cache';

import './index.css';
import App from './App';
import store from './store';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <Provider store={store}>
    <ClearCacheProvider duration={2 * 60 * 1000}>
      <App />
    </ClearCacheProvider>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.register();
